import jsonp from 'jsonp';
import { encode } from './form';

export default function mailerliteSubmit(userId, listId, values) {
  const newValues = {
    'fields[email]': values.EMAIL,
    'ml-submit': '1',
    anticsrf: 'true',
    ajax: '1',
  };

  const url = `//assets.mailerlite.com/jsonp/${userId}/forms/${listId}/subscribe?${encode(newValues)}`;

  return new Promise((resolve, reject) => {
    jsonp(
      url,
      {
        timeout: 5000,
        name: 'mlWebformSubmitted',
      },
      (err, data) => {
        if (err || !data.success) {
          const message = err instanceof Error ? err.message : 'Unknown';

          reject(new Error(message));
        }

        resolve(true);
      }
    );
  });
}
